import { Component } from "@angular/core";
import { Router } from "@angular/router";
import {
  NgbCarouselConfig,
  NgbCarouselModule,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-home-main-banner-slider",
    imports: [NgbCarouselModule],
    templateUrl: "./home-main-banner-slider.component.html",
    styleUrl: "./home-main-banner-slider.component.scss"
})
export class HomeMainBannerSliderComponent {
  images: string[] = [
    "./../../../../assets/images/banner-festa-dos-corin-2.jpg",
    "./../../../../assets/images/home/music-fest-banner.jpg",
    "./../../../../assets/images/home/banner-700.jpg",
    "./../../../../assets/images/home/banner-700-2.jpg",
  ];

  constructor(
    config: NgbCarouselConfig,
    private readonly router: Router,
  ) {
    config.interval = 3000;
    config.wrap = false;
    config.keyboard = true;
    config.pauseOnHover = false;
    config.showNavigationIndicators = true;
    config.showNavigationArrows = true;
  }

  goToEvent() {
    this.router.navigate(["/event/545"]);
  }
}
